import React, { useEffect, useState } from "react";
import get from "lodash/get";

import Separator from "../../atoms/separator";

import StoryCard20 from "../../molecules/story-card20";
import StoryCard18 from "../../molecules/story-card18";
import TopNewsLatest from "../../molecules/top-news-latest";
import CollectionName from "../../molecules/collection-name";
import CollectionTitleHeader from "../../molecules/collection-title-header";

import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";

import "./top-news-2.m.css";

function TopNews2({ collection, index }) {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  if (!stories.length) {
    return null;
  }
  return (
    <>
      <div className="hide-mobile">
        <CollectionTitleHeader collection={collection} index={index} />
        <div styleName="wrapper">
          <div styleName="col1">
            {stories?.slice(0, 1).map((item, index) => (
              <div key={index} styleName="col1-card">
                <StoryCard18 story={item} />
              </div>
            ))}
            <div styleName="col1-latest">
              <TopNewsLatest stories={stories} />
            </div>
          </div>
          <div styleName="col2">
            {stories?.slice(4, 11).map((item, index) => (
              <div styleName="col2-card" key={index}>
                <StoryCard20 story={item} />
              </div>
            ))}
          </div>
        </div>
        <Separator />
      </div>
      {isMobile ? (
        <div className="hide-desktop">
          <CollectionName collection={collection} />
          <div styleName="wrapper">
            <div styleName="section">
              {stories?.slice(0, 1).map((item, index) => (
                <div key={index} styleName="col1-card">
                  <StoryCard18 story={item} />
                </div>
              ))}
            </div>
            <div styleName="section">
              {stories.slice(1, 5).map((item, idx) => (
                <>
                  <div styleName="small-card" key={idx}>
                    <StoryCard20 story={item} key={idx} />
                  </div>
                  {idx === 1 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
                </>
              ))}
            </div>
            <div styleName="section">
              {stories.slice(5, 11).map((item, idx) => (
                <>
                  <div styleName="small-card" key={idx}>
                    <StoryCard20 story={item} key={idx} />
                  </div>
                  {idx === 1 ? <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} /> : null}
                  {idx === 5 ? <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} /> : null}
                </>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default TopNews2;
